import { BimViewerAdapter } from 'Data/interfaces/BimViewer/IBimViewerPort';
import { IfcLiteViewerAdapter } from './IfcLiteViewerAdapter';

// Factory do motor 3D. Trocar de motor (ex.: fallback three.js) = retornar outro
// adaptador que implemente BimViewerAdapter; o app não muda.
export function createBimViewerAdapter(): BimViewerAdapter {
  return new IfcLiteViewerAdapter();
}
